import { useRouter } from 'next/router';

export default function useFeatureFlags() {
  const router = useRouter();

  const { isMVPLaunched } = router.query;
  return {
    isMVPLaunched:
      isMVPLaunched === 'true' ||
      process.env.IS_MVP_LAUNCHED ||
      process.env.NODE_ENV === 'development',
    isFollowEnabled: process.env.NODE_ENV === 'development',
  };
}
